<script setup lang="ts">
import { Handshake, Mail, Sparkles } from '@lucide/vue';
import EarlyAccessForm from '@/components/marketing/shared/EarlyAccessForm.vue';

const benefits = [
    {
        icon: Sparkles,
        title: 'First in line',
        description:
            'Your invite arrives before we open registration to everyone else.',
    },
    {
        icon: Handshake,
        title: 'A say in what we build',
        description:
            'The first users shape the roadmap. Tell us what your business needs most.',
    },
    {
        icon: Mail,
        title: 'No card, no commitment',
        description:
            'We only keep your email and, if you share it, your website. Nothing else.',
    },
];
</script>

<template>
    <section id="early-access" class="scroll-mt-24 py-16 sm:py-20">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div
                class="from-primary/8 border-border overflow-hidden rounded-3xl border bg-gradient-to-br to-transparent p-6 sm:p-10"
            >
                <div class="grid gap-10 lg:grid-cols-2 lg:items-center">
                    <div class="flex flex-col gap-6">
                        <h2
                            class="font-display text-3xl leading-[1.15] text-balance sm:text-4xl"
                        >
                            Be first in line.
                        </h2>
                        <p class="text-muted-foreground max-w-lg text-lg">
                            Early access is invite only while we finish building
                            the assistant. Join the list and we will send your
                            invite as soon as your business can use it.
                        </p>

                        <ul class="grid gap-4">
                            <li
                                v-for="benefit in benefits"
                                :key="benefit.title"
                                class="flex gap-3"
                            >
                                <span
                                    class="bg-card border-border inline-flex size-9 shrink-0 items-center justify-center rounded-lg border"
                                >
                                    <component
                                        :is="benefit.icon"
                                        class="text-primary size-4"
                                        aria-hidden="true"
                                    />
                                </span>
                                <div>
                                    <p class="text-sm font-medium">
                                        {{ benefit.title }}
                                    </p>
                                    <p
                                        class="text-muted-foreground text-sm leading-relaxed"
                                    >
                                        {{ benefit.description }}
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div
                        class="bg-card border-border rounded-2xl border p-6 shadow-sm"
                    >
                        <h3 class="text-lg">Join the early access list</h3>
                        <p class="text-muted-foreground mt-1 mb-4 text-sm">
                            Tell us where to send your invite.
                        </p>
                        <EarlyAccessForm id-prefix="early-access-section" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
